const appRedirect = (url: string, base?: string): void => {
  if (base) {
    window.location.href = base + url;
  } else window.location.replace(url);
};

export default appRedirect;
